import React, {Component} from "react";
import "./PublicForm.css";
import {Wizard} from "../../../components";
import ValidationUtil from "../../../components/form/validator/ValidationUtil";
import RemotingService from "../../../services/remoting-service/RemotingService";
import DateUtil from "../../../utils/DateUtil";
import moment from "moment";
import confirmDialog from "../../../components/dialog/ConfirmDialog";
import IntakeFormRadTextEnum from "../intakeformrad/enum/IntakeFormRadTextEnum";
import IntakeFormRadPersonalInformation from "../intakeformrad/IntakeFormRadPersonalInformation";
import IntakeFormRadContactInformation from "../intakeformrad/IntakeFormRadContactInformation";
import IntakeFormRadReferralInformation from "../intakeformrad/IntakeFormRadReferralInformation";
import IntakeFormRadEmergencyContact from "../intakeformrad/IntakeFormRadEmergencyContact";
import IntakeFormRadHealthHistory from "../intakeformrad/IntakeFormRadHealthHistory";
import NabidhConsentFormParts from "../nabidh/NabidhConsentFormParts";
import NabidhFormTextEnum from "../NabidhFormTextEnum";
import PatientUtil from "../../../utils/PatientUtil";
import ClinicLogo from "../../../layout/ClinicLogo";
import {connect} from "react-redux";
import LookupService from "../../../services/lookup/LookupService";

class PublicIntakeFormRad extends Component {
    constructor(props) {
        super(props);

        this.state = {};
    }

    componentDidMount() {
        this.retrievePatientPhoto();

        const {form} = this.props;

        if (form.dob && !form.age) {
            form.age = DateUtil.getAgeWithMonths(moment(form.dob));
        }

        // Ensure allergy object is initialized to maintain reference with FormAllergiesSection
        if (!form.allergy) {
            form.allergy = {};
        }

        // Initialize Nabidh consent fields if not present
        if (!form.nabidhConsent) {
            form.nabidhConsent = {
                consentType: null,
                patientSignature: null,
                witnessName: "",
                witnessSignature: null,
                relationshipToPatient: ""
            };
        }

        // Initialize top-level fields for easier access
        if (form.nabidhWitnessName === undefined) {
            form.nabidhWitnessName = form.nabidhConsent.witnessName || "";
        }
        if (form.nabidhWitnessSignature === undefined) {
            form.nabidhWitnessSignature = form.nabidhConsent.witnessSignature || null;
        }
        if (form.nabidhRelationshipToPatient === undefined) {
            form.nabidhRelationshipToPatient = form.nabidhConsent.relationshipToPatient || "";
        }
        if (form.patientSignature === undefined) {
            form.patientSignature = form.nabidhConsent.patientSignature || null;
        }

        // Match lookup objects from Redux store for SelectInput compatibility
        this.matchLookupObjects(form);

        this.forceUpdate();
    }

    matchLookupObjects = (form) => {
        const {relationshipTypes, nationalities, countries, maritalStatuses, religions, languages} = this.props;

        // Match emergency contact relationship type
        const relationshipTypeObject = LookupService.matchLookupObject(
            form.emergencyContactRelationshipType,
            relationshipTypes
        );
        if (relationshipTypeObject) {
            form.emergencyContactRelationshipType = relationshipTypeObject;
        }

        // Match nationality lookup field
        const nationalityObject = LookupService.matchLookupObject(
            form.nationality,
            nationalities
        );
        if (nationalityObject) {
            form.nationality = nationalityObject;
        }

        // Match country lookup field
        const countryObject = LookupService.matchLookupObject(
            form.country,
            countries
        );
        if (countryObject) {
            form.country = countryObject;
        }

        // Match marital status lookup field
        const maritalStatusObject = LookupService.matchLookupObject(
            form.maritalStatus,
            maritalStatuses
        );
        if (maritalStatusObject) {
            form.maritalStatus = maritalStatusObject;
        }

        // Match religion lookup field
        const religionObject = LookupService.matchLookupObject(
            form.religion,
            religions
        );
        if (religionObject) {
            form.religion = religionObject;
        }

        // Match language lookup field
        const languageObject = LookupService.matchLookupObject(
            form.language,
            languages
        );
        if (languageObject) {
            form.language = languageObject;
        }

        // Match family history "who" fields
        const familyWhoFields = [
            'asthmaFamilyWho', 'tuberculosisFamilyWho', 'pneumoniaFamilyWho', 'covid19FamilyWho',
            'cancerFamilyWho', 'osteoarthritisFamilyWho', 'osteoporosisFamilyWho', 'rheumatoidArthritisFamilyWho',
            'thyroidDiseaseFamilyWho', 'abdominalDiseasesFamilyWho', 'breastDiseasesFamilyWho',
            'diabetesFamilyWho', 'kidneyDiseaseFamilyWho', 'heartDiseaseFamilyWho', 'otherConditionFamilyWho'
        ];

        familyWhoFields.forEach(field => {
            if (form[field]) {
                const matchedObject = LookupService.matchLookupObject(form[field], relationshipTypes);
                if (matchedObject) {
                    form[field] = matchedObject;
                }
            }
        });
    }

    retrievePatientPhoto = () => {
        const {consentFormCode: code} = this.props;

        RemotingService.getRemoteCall(
            `api/public/consent-form/code/${code}/patient-photo`,
            null,
            (profilePhoto) => {
                this.setState({
                    photoValue: profilePhoto,
                    newPhotoValue: profilePhoto,
                });
            }
        );
    };

    close = () => {
        confirmDialog(
            "Confirmation",
            "Are you sure you want to close this form? All input will be lost.",
            this.props.close
        );
    };

    submitForm = () => {
        if (ValidationUtil.checkWithNotification(this.formFields)) {
            const {consentFormCode: code, form} = this.props;
            
            // Structure nabidhConsent properly before submission
            form.nabidhConsent = {
                consentType: form.nabidhConsent?.consentType || null,
                patientSignature: form.patientSignature,
                witnessName: form.nabidhWitnessName,
                witnessSignature: form.nabidhWitnessSignature,
                relationshipToPatient: form.nabidhRelationshipToPatient,
                patientFullName: form.patientFullName || PatientUtil.getPatientName(form.firstName, form.middleName, form.lastName),
                patientMrn: form.patientMrn || "",
                patientDOB: form.dob || null
            };
            
            RemotingService.postRemoteCall(
                `api/public/consent-form/code/${code}/intake-form-rad`,
                form
            );
            this.props.onFormSubmit(form);
        }
    };

    createHeader = (form, selectedLanguage) => {
        let headerClass = selectedLanguage === "Arabic"
            ? "arabic-form d-flex justify-content-between align-items-center"
            : "d-flex justify-content-between align-items-center";

        return (
            <div style={{padding: "0px 20px 0px 20px"}}>
                <div className="row text-left">
                    <div className="col-12 no-padding">
                        <ClinicLogo/>
                    </div>
                </div>
                <div className="row">
                    <div
                        className="col-12 text-center no-padding"
                        style={{fontSize: 20, fontWeight: "bold"}}
                    >
                        {IntakeFormRadTextEnum.Intake_Form_Rad_Header[selectedLanguage]}
                    </div>
                </div>
                <div className={headerClass} style={{fontSize: 11}}>
                    <div className="mb-0">
                        <b>{IntakeFormRadTextEnum.Date[selectedLanguage]}: </b> 
                        <span dir="ltr">{DateUtil.formatDateMMM(form.consentDate)}</span>
                    </div>
                    <div className="mb-0">
                        <b>{IntakeFormRadTextEnum.MRN[selectedLanguage]}: </b> {form.patientMrn}
                    </div>
                </div>
            </div>
        );
    };

    fieldChanged = (fieldName, value) => {
        this.props.form[fieldName] = value;
        this.forceUpdate();
    };

    fieldGroupChanged = (fieldGroupObject, value, validationCallback) => {
        Object.keys(fieldGroupObject).forEach(fieldName => {
            this.props.form[fieldName] = fieldGroupObject[fieldName];
        });
        
        if (validationCallback) {
            validationCallback(this);
        }
        this.forceUpdate();
    };

    pushFormFieldRef = (ref) => this.formFields.push(ref);

    onSavePatientSignature = (signature) => {
        this.props.form.patientSignature = signature;
        this.forceUpdate();
    };

    onSaveNabidhWitnessSignature = (signature) => {
        this.props.form.nabidhWitnessSignature = signature;
        this.forceUpdate();
    };

    render() {
        this.formFields = [];

        const {form, language: selectedLanguage, nationalities, countries, maritalStatuses, religions, languages, allergyTypes, allergenTypes, allergySeverities, allergenReactionTypes} = this.props;
        const {photoValue} = this.state;
        const photoSrc = photoValue
            ? `data:image/jpeg;base64,${photoValue.content}`
            : `${process.env.PUBLIC_URL}/assets/patient_profile.png`;

        const formBodyClass = selectedLanguage === "Arabic" ? "arabic-form" : "";
        const maxWidthClass = "form-body";
        const enumLabel = selectedLanguage === "Arabic" ? "nameInArabic" : "name";
        const nationalityLabel = selectedLanguage === "Arabic" ? "nameInArabic" : "nameInEnglish";
        const patientName = form.patientFullName || PatientUtil.getPatientName(form.firstName, form.middleName, form.lastName);
        const mrnNo = form.patientMrn || "";
        
        const commonProps = {
            selectedLanguage,
            enumLabel,
            nationalityLabel,
            readOnly: false,
            onChange: this.fieldChanged,
            onFieldGroupChanged: this.fieldGroupChanged,
            formFields: this.formFields,
            pushFormFieldRef: this.pushFormFieldRef
        }

        return (
            <Wizard
                show={true}
                fullScreen
                footerStyle={{backgroundColor: "#f5f5f5"}}
                buttonStyle={{backgroundColor: "#84BE56", border: "none"}}
                previousButtonStyle={{
                    backgroundColor: "#fff",
                    color: "rgb(132, 190, 86)",
                    borderColor: "rgb(132, 190, 86)"
                }}
                header={this.createHeader(form, selectedLanguage)}
                close={this.close}
                onSubmit={this.submitForm}
                previousBtnText={IntakeFormRadTextEnum.Wizard_Previous[selectedLanguage]}
                nextBtnText={IntakeFormRadTextEnum.Wizard_Next[selectedLanguage]}
                saveBtnText={IntakeFormRadTextEnum.Wizard_Save[selectedLanguage]}
            >
                {/* Page 1: Personal & Contact Information */}
                <Wizard.Page
                    onNext={(event) => ValidationUtil.stopEventPropagationIfValidationFails(event, this.formFields)}
                    onPrevious={() => this.formFields = []}>

                    <div style={{width: "1000px"}}>
                        <div style={{padding: "20px", textAlign: "center", marginBottom: "20px"}}>
                            <img 
                                src={photoSrc} 
                                alt="Patient"
                                style={{width: "100px", height: "100px", borderRadius: "50%", objectFit: "cover"}}
                            />
                            <h4 className="mt-2">{IntakeFormRadTextEnum.Intake_Form_Rad_Title[selectedLanguage]}</h4>
                        </div>

                        <div className={formBodyClass}>
                            <IntakeFormRadPersonalInformation {...commonProps}
                                                              firstName={form.firstName}
                                                              middleName={form.middleName}
                                                              lastName={form.lastName}
                                                              dob={form.dob}
                                                              age={form.age}
                                                              gender={form.gender}
                                                              idNo={form.idNo}
                                                              nationality={form.nationality}
                                                              nationalities={nationalities}
                                                              maritalStatus={form.maritalStatus}
                                                              maritalStatuses={maritalStatuses}
                                                              religion={form.religion}
                                                              religions={religions}
                                                              language={form.language}
                                                              languages={languages}
                                                              haveAllergies={form.haveAllergies}
                                                              allergy={form.allergy}
                                                              allergyTypes={allergyTypes}
                                                              allergenTypes={allergenTypes}
                                                              allergySeverities={allergySeverities}
                                                              allergenReactionTypes={allergenReactionTypes}
                            />

                            <IntakeFormRadContactInformation {...commonProps}
                                                             phoneNumber={form.phoneNumber}
                                                             whatsappNumber={form.whatsappNumber}
                                                             email={form.email}
                                                             address={form.address}
                                                             country={form.country}
                                                             countries={countries}
                                                             city={form.city}
                                                             postalCode={form.postalCode}
                            />
                        </div>
                    </div>
                </Wizard.Page>

                {/* Page 2: Referral & Emergency Contact Information */}
                <Wizard.Page
                    onNext={(event) => ValidationUtil.stopEventPropagationIfValidationFails(event, this.formFields)}
                    onPrevious={() => this.formFields = []}>
                    <div className={formBodyClass + " my-2"} style={{width: "1000px"}}>
                        <IntakeFormRadReferralInformation {...commonProps}
                                                          howHeardAboutClinic={form.howHeardAboutClinic}
                                                          referringPhysician={form.referringPhysician}
                                                          reasonForImaging={form.reasonForImaging}
                        />

                        <IntakeFormRadEmergencyContact {...commonProps}
                                                       emergencyContactName={form.emergencyContactName}
                                                       emergencyContactRelationshipType={form.emergencyContactRelationshipType}
                                                       emergencyContactPhone={form.emergencyContactPhone}
                        />
                    </div>
                </Wizard.Page>

                {/* Page 3: Health History */}
                <Wizard.Page 
                    onNext={(event) => ValidationUtil.stopEventPropagationIfValidationFails(event, this.formFields)}
                    onPrevious={() => this.formFields = []}>
                    <div className={formBodyClass + " my-2"} style={{width: "1000px"}}>
                        <IntakeFormRadHealthHistory {...commonProps}
                                                    markAllSelf={form.markAllSelf}
                                                    markAllFamily={form.markAllFamily}
                                                    asthmaSelf={form.asthmaSelf}
                                                    asthmaFamily={form.asthmaFamily}
                                                    tuberculosisSelf={form.tuberculosisSelf}
                                                    tuberculosisFamily={form.tuberculosisFamily}
                                                    pneumoniaSelf={form.pneumoniaSelf}
                                                    pneumoniaFamily={form.pneumoniaFamily}
                                                    covid19Self={form.covid19Self}
                                                    covid19Family={form.covid19Family}
                                                    cancerSelf={form.cancerSelf}
                                                    cancerFamily={form.cancerFamily}
                                                    osteoarthritisSelf={form.osteoarthritisSelf}
                                                    osteoarthritisFamily={form.osteoarthritisFamily}
                                                    osteoporosisSelf={form.osteoporosisSelf}
                                                    osteoporosisFamily={form.osteoporosisFamily}
                                                    rheumatoidArthritisSelf={form.rheumatoidArthritisSelf}
                                                    rheumatoidArthritisFamily={form.rheumatoidArthritisFamily}
                                                    thyroidDiseaseSelf={form.thyroidDiseaseSelf}
                                                    thyroidDiseaseFamily={form.thyroidDiseaseFamily}
                                                    abdominalDiseasesSelf={form.abdominalDiseasesSelf}
                                                    abdominalDiseasesFamily={form.abdominalDiseasesFamily}
                                                    breastDiseasesSelf={form.breastDiseasesSelf}
                                                    breastDiseasesFamily={form.breastDiseasesFamily}
                                                    diabetesSelf={form.diabetesSelf}
                                                    diabetesFamily={form.diabetesFamily}
                                                    kidneyDiseaseSelf={form.kidneyDiseaseSelf}
                                                    kidneyDiseaseFamily={form.kidneyDiseaseFamily}
                                                    heartDiseaseSelf={form.heartDiseaseSelf}
                                                    heartDiseaseFamily={form.heartDiseaseFamily}
                                                    otherConditionSelf={form.otherConditionSelf}
                                                    otherConditionFamily={form.otherConditionFamily}

                                                    asthmaFamilyWho={form.asthmaFamilyWho}
                                                    tuberculosisFamilyWho={form.tuberculosisFamilyWho}
                                                    pneumoniaFamilyWho={form.pneumoniaFamilyWho}
                                                    covid19FamilyWho={form.covid19FamilyWho}
                                                    cancerFamilyWho={form.cancerFamilyWho}
                                                    osteoarthritisFamilyWho={form.osteoarthritisFamilyWho}
                                                    osteoporosisFamilyWho={form.osteoporosisFamilyWho}
                                                    rheumatoidArthritisFamilyWho={form.rheumatoidArthritisFamilyWho}
                                                    thyroidDiseaseFamilyWho={form.thyroidDiseaseFamilyWho}
                                                    abdominalDiseasesFamilyWho={form.abdominalDiseasesFamilyWho}
                                                    breastDiseasesFamilyWho={form.breastDiseasesFamilyWho}
                                                    diabetesFamilyWho={form.diabetesFamilyWho}
                                                    kidneyDiseaseFamilyWho={form.kidneyDiseaseFamilyWho}
                                                    heartDiseaseFamilyWho={form.heartDiseaseFamilyWho}
                                                    otherConditionFamilyWho={form.otherConditionFamilyWho}

                                                    onMedicationSupplements={form.onMedicationSupplements}
                                                    medicationDetails={form.medicationDetails}
                                                    everHadSurgery={form.everHadSurgery}
                                                    surgeryDetails={form.surgeryDetails}
                                                    currentlyReceivingHealthcare={form.currentlyReceivingHealthcare}
                                                    healthcareDetails={form.healthcareDetails}
                                                    hadPreviousImaging={form.hadPreviousImaging}
                                                    previousImagingDetails={form.previousImagingDetails}
                                                    exerciseType={form.exerciseType}
                                                    smokesCurrent={form.smokesCurrent}
                                                    smokesHistory={form.smokesHistory}
                                                    consumesAlcohol={form.consumesAlcohol}
                                                    currentlyPregnant={form.currentlyPregnant}
                                                    lastMenstrualPeriod={form.lastMenstrualPeriod}
                                                    lastMenstrualPeriodDetails={form.lastMenstrualPeriodDetails}
                                                    hadContrastDyeLast6Days={form.hadContrastDyeLast6Days}
                                                    calciumVitaminDToday={form.calciumVitaminDToday}
                                                    calciumVitaminDLast24Hours={form.calciumVitaminDLast24Hours}
                                                    nuclearMedicineScanBariumLast6Days={form.nuclearMedicineScanBariumLast6Days}
                                                    dexaScanLast12Months={form.dexaScanLast12Months}
                                                    fastingForUltrasoundXray={form.fastingForUltrasoundXray}
                        />
                    </div>
                </Wizard.Page>

                {/* Page 4: NABIDH Consent Form - Information */}
                <Wizard.Page
                    onNext={(event) => ValidationUtil.stopEventPropagationIfValidationFails(event, this.formFields)}
                    onPrevious={() => this.formFields = []}>
                    <div className={`${formBodyClass} ${maxWidthClass}`}>
                        <h3 className="text-center mb-4">
                            <b>{NabidhFormTextEnum.Nabidh_Consent_Form_Title[selectedLanguage]}</b>
                        </h3>
                        <NabidhConsentFormParts.PatientInformation
                            selectedLanguage={selectedLanguage}
                            patientName={patientName}
                            mrnNo={mrnNo}
                            patientDOB={form.dob}
                        />
                        <NabidhConsentFormParts.NabidhInformation selectedLanguage={selectedLanguage}/>

                        <NabidhConsentFormParts.PatientSignatureSection
                            selectedLanguage={selectedLanguage}
                            readOnly={false}
                            consentDate={form.consentDate || new Date()}
                            patientName={patientName}
                            patientSignature={form.patientSignature}
                            onSavePatientSignature={this.onSavePatientSignature}
                            pushFormFieldRef={this.pushFormFieldRef}
                        />
                    </div>
                </Wizard.Page>

                {/* Page 5: NABIDH Consent Form - Witness Section */}
                <Wizard.Page onPrevious={() => this.formFields = []}>
                    <div className={`${formBodyClass} ${maxWidthClass}`}>
                        <NabidhConsentFormParts.WitnessSection
                            selectedLanguage={selectedLanguage}
                            readOnly={false}
                            witnessName={form.nabidhWitnessName}
                            witnessSignature={form.nabidhWitnessSignature}
                            relationshipToPatient={form.nabidhRelationshipToPatient}
                            onWitnessNameChange={(val) => {
                                this.props.form.nabidhWitnessName = val;
                                this.forceUpdate();
                            }}
                            onRelationshipChange={(val) => {
                                this.props.form.nabidhRelationshipToPatient = val;
                                this.forceUpdate();
                            }}
                            onSaveWitnessSignature={this.onSaveNabidhWitnessSignature}
                        />
                    </div>
                </Wizard.Page>
            </Wizard>
        );
    }
}

function mapStateToProps(state) {
    return {
        nationalities: state.base.lookupNationalities,
        countries: state.base.lookupCountries,
        relationshipTypes: state.base.relationshipTypes,
        maritalStatuses: state.base.lookupMaritalStatuses,
        religions: state.base.lookupReligions,
        languages: state.base.lookupLanguages,
        allergyTypes: state.base.allergyTypes,
        allergenTypes: state.base.allergenTypes,
        allergySeverities: state.base.allergySeverities,
        allergenReactionTypes: state.base.allergenReactionTypes
    };
}

export default connect(mapStateToProps)(PublicIntakeFormRad);